import React from "react";
import "./ComingSoon.css";

const ComingSoon = () => {
  return (
    <div className="fallback-tag-container">
      {/* Confetti Shapes */}
      <svg className="fallback-tag-confetti">
        {/* Dots */}
        <circle cx="50" cy="50" r="5" fill="black" />
        <circle cx="100" cy="200" r="5" fill="black" />
        <circle cx="300" cy="100" r="5" fill="black" />
        <circle cx="500" cy="300" r="5" fill="black" />
        <circle cx="700" cy="150" r="5" fill="black" />

        {/* Lines */}
        <rect
          x="150"
          y="50"
          width="20"
          height="5"
          fill="#FF6F61"
          transform="rotate(45 160 55)"
        />
        <rect
          x="200"
          y="300"
          width="20"
          height="5"
          fill="#6B5B95"
          transform="rotate(-30 210 305)"
        />
        <rect
          x="400"
          y="200"
          width="20"
          height="5"
          fill="#88B04B"
          transform="rotate(60 410 205)"
        />
        <rect
          x="600"
          y="50"
          width="20"
          height="5"
          fill="#F7CAC9"
          transform="rotate(15 610 55)"
        />

        {/* Crosses */}
        <path
          d="M250 150 L260 160 M260 150 L250 160"
          stroke="#F4A261"
          strokeWidth="3"
        />
        <path
          d="M350 300 L360 310 M360 300 L350 310"
          stroke="#5DADE2"
          strokeWidth="3"
        />
        <path
          d="M650 200 L660 210 M660 200 L650 210"
          stroke="#F7CAC9"
          strokeWidth="3"
        />
      </svg>

      {/* Main Content */}
      <div className="fallback-tag-content">
        <h1>COMING SOON</h1>
        <p>
          NIAVH is launching soon with smarter recommendations and routines that
          fit your life.
        </p>
        <button>Thank You!</button>{" "}
      </div>

      {/* Footer */}
      <footer className="fallback-Footer">
        <p>© 2026 NIAVH. All rights reserved. | Built by Beyowned Solutions</p>
      </footer>
    </div>
  );
};

export default ComingSoon;
